/* eslint-disable no-prototype-builtins */
import axios from 'axios'

export default {
  /**
   * Fetch json with cookie information by given Path.
   * @param path
   */
  fetchConfig (path) {
    return axios.get(path)
  }
}
